// L'équipe de l'organisation : sièges, membres, invitations, rôles (V4Equipe).
export default {
  titre: 'Équipe',
  chargement: 'Chargement…',
  fermer: 'Fermer',
  acces: {
    administrateur: 'Administrateur',
    role: 'Rôle',
    personnalise: 'Accès personnalisés',
  },
  // Ce que l'accès permet, par niveau (`libelleNiveau` du domaine, en clair).
  niveau: {
    analyst: 'Lance des études',
    viewer: 'Consulte',
  },
  gereEquipe: 'Gère l’équipe',
  panneau: {
    inviter: 'Inviter une personne',
    creerRole: 'Créer un rôle',
    envoyee: 'Invitation envoyée',
    prete: 'Invitation prête',
    // L'invitation en deux étapes (15 octobre 2026).
    pas: {
      qui: 'Qui',
      acces: 'Son accès',
    },
  },
  erreur: {
    choisirRole: 'Choisissez un rôle.',
    email: 'Une adresse e-mail complète, par exemple prenom.nom@exemple.fr.',
  },
  annonce: {
    accesMisAJour: 'Accès mis à jour.',
    roleCree: 'Rôle créé.',
    roleMisAJour: 'Rôle mis à jour.',
    retire: '{email} ne fait plus partie de l’équipe.',
    invitationRetiree: 'Invitation retirée.',
    roleSupprime: 'Rôle supprimé.',
    lienCopie: 'Lien copié.',
    copieImpossible: 'Copie impossible : sélectionnez le lien.',
  },
  confirmer: {
    retirer: 'Retirer {email} de l’équipe ? Son siège se libère.',
    retirerInvitation: 'Retirer l’invitation de {email} ? Son lien ne marchera plus.',
    supprimerRole: 'Supprimer le rôle « {nom} » ?',
    titre: {
      retirer: 'Retirer ce membre',
      retirerInvitation: 'Retirer l’invitation',
      supprimerRole: 'Supprimer le rôle',
    },
    bouton: {
      retirer: 'Retirer',
      supprimer: 'Supprimer',
    },
  },
  sieges: {
    titre: 'Sièges',
    sur: 'sur {n}',
    inviter: 'Inviter',
    complet: 'Tous les sièges sont occupés',
  },
  membres: {
    titre: 'Membres',
    vous: 'Vous',
    equipeOrion: 'Équipe Orion',
    derniereConnexion: 'Dernière connexion le {date}',
    aucuneConnexion: 'Aucune connexion',
    aucunModule: 'Aucun module',
    modifier: 'Modifier',
    retirer: 'Retirer de l’équipe',
    personne: 'Personne pour l’instant.',
  },
  invitations: {
    expire: 'Lien expiré',
    du: 'Invitation du {date}',
    nouveauLien: 'Nouveau lien',
    retirer: 'Retirer l’invitation',
  },
  roles: {
    titre: 'Rôles',
    creer: 'Créer un rôle',
    personnes: '{n} personne | {n} personne | {n} personnes',
    supprimer: 'Supprimer le rôle',
    aucun: 'Aucun rôle.',
  },
  lien: {
    emailParti: 'Un e-mail est parti pour',
    envoyez: 'Envoyez ce lien à',
    copier: 'Copier le lien',
    valable: 'Valable jusqu’au {date}.',
  },
  formulaire: {
    email: 'Adresse e-mail',
    emailExemple: "prenom.nom{'@'}exemple.fr",
    acces: 'Accès',
    peutLancer: 'Peut lancer des études',
    unInstant: 'Un instant…',
    inviter: 'Inviter',
    enregistrer: 'Enregistrer',
    nomRole: 'Nom du rôle',
    nomRoleExemple: 'Analyste Projector',
    modules: 'Modules',
    creerRole: 'Créer le rôle',
  },
}
